// extracted by mini-css-extract-plugin
module.exports = {"section":"section__1KZ3r","title":"title__2rvEb","body":"body__20NMY"};